import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AuditNodeViewModel } from 'src/app/business/swodoc/view-models/audit-node-view-model';

@Component({
  selector: 'swodoc-node-header',
  template: '{{ node.title }}',
  styleUrls: ['./swodoc-node-header.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwodocNodeHeader {
  @Input()
  node: AuditNodeViewModel;
}
